import { EntityTablePage } from "../../common/entity/EntityTablePage";
import { CustomTypeTemplateManager } from "./CustomTypeTemplateManager";

export const CustomTypeTemplatesTablePage = () => {
  return (
    <EntityTablePage entityTypeId={"customTypeTemplates"}>{(props) => <CustomTypeTemplateManager />}</EntityTablePage>
  );
};
